import { Button, Modal } from 'flowbite-react';
import React from 'react';
import { RxCross2 } from 'react-icons/rx';

interface Props {
	isOpen: boolean;
	isLoading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const CloseRecruiterPositionConfirmationModal = ({ isOpen, onClose, onConfirm, isLoading = false }: Props) => {
	return (
		<Modal size="md" show={isOpen} onClose={onClose} dismissible>
			<Modal.Body className="relative rounded-[8px] border border-solid dark:border-[#4B5563] bg-whtie dark:bg-[#1F2A37]">
				<div className="text-center mt-[20px] text-base font-[600] text-inherit dark:text-[#F2F2F5]">
					Are you sure you want to close this position?
				</div>

				<div className="flex gap-4 justify-center mt-[20px]">
					<Button
						color="light"
						onClick={onClose}
						disabled={isLoading}
						className="!border !border-solid !border-[#7777E7]"
					>
						No, cancel
					</Button>
					<Button onClick={onConfirm} color="purplePlaced" disabled={isLoading} isProcessing={isLoading}>
						Yes, I am sure
					</Button>
				</div>

				<RxCross2
					onClick={onClose}
					className="absolute right-[16px] top-[16px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
				/>
			</Modal.Body>
		</Modal>
	);
};

export default CloseRecruiterPositionConfirmationModal;
